module.exports = __webpack_public_path__ + "img/origami_neigborhood_cafe.9ec06eb2.jpg";